import React from 'react';
import { useTranslation } from 'react-i18next';

import { FaFacebookSquare, FaInstagram, FaTwitterSquare } from 'react-icons/fa';
import { Link } from 'react-router-dom';

import SLI_Logo from '../assets/Logo.svg';
import UC_RGPO_Logo from '../assets/UC-RGPO_logo.jpg';
import { ROUTES } from '../constants/routes';

const Footer = () => {
  const { t } = useTranslation();

  return (
    <>
      <div className="h-[2rem] w-auto bg-[#44753E]"></div>
      <div className="mx-auto py-12 md:py-12 px-2 grid lg:grid-cols-3 gap-2 bg-[#44753E] text-[#FFFAF8]">
        <div>
          <img
            className="w-[100px] mx-auto my-0 md:my-2"
            src={SLI_Logo}
            alt={t('footer.logoAlt')}
          />
          <div className="flex justify-center md:w-[55%] my-6 mx-auto">
            <FaFacebookSquare size={30} className="mx-2" />
            <FaInstagram size={30} className="mx-2" />
            <FaTwitterSquare size={30} className="mx-2" />
          </div>
        </div>
        <div className="lg:col-span-2 flex gap-5 justify-evenly mt-2 md:text-end">
          <div>
            <ul>
              <Link to={ROUTES.HOME}>
                <li className="font-medium">{t('footer.nav.home')}</li>
              </Link>
              <Link to={ROUTES.ABOUT_US}>
                <li className="font-medium">{t('footer.nav.aboutSLI')}</li>
              </Link>
              <Link to={ROUTES.TEMP_FARM_SHARE}>
                <li className="font-medium">{t('footer.nav.farmshare')}</li>
              </Link>
              <Link to={ROUTES.EVENTS}>
                <li className="font-medium">{t('footer.nav.events')}</li>
              </Link>
              <Link to={ROUTES.RESOURCES}>
                <li className="font-medium">{t('footer.nav.resources')}</li>
              </Link>
              <Link to="https://www.us-ltrcd.org/contact-us" target="_blank">
                <li className="font-medium">{t('footer.nav.contactUs')}</li>
              </Link>
            </ul>
          </div>
          <div>
            <ul>
              <Link to="https://www.ucop.edu/research-grants-program/index.html" target="_blank">
                <li className="font-medium text-left md:text-center max-w-[30vw]">
                  {t('footer.ucSupport')}
                </li>
              </Link>
              {/*
              <li className="py-2">Login</li>


              <li className="py-2">Shop</li>
              <li className="py-2">FAQs</li>
            */}
            </ul>
            <img
              className="w-[80px] md:mx-auto my-4"
              src={UC_RGPO_Logo}
              alt={t('footer.ucLogoAlt')}
            />
          </div>

          {/*<div>
            <Link to={ROUTES.EVENTS}>
              <h6 className="font-medium">Events</h6>
            </Link>
            <ul>
              <li className="py-2">Workshops</li>
              <li className="py-2">Blog</li>
              <li className="py-2">Jobs</li>
            </ul>
          </div>
          <div>
            <Link to={ROUTES.RESOURCES}>
              <h6 className="font-medium">Resources</h6>
            </Link>
            <ul>
              <li className="py-2">Donations</li>
              <li className="py-2">Policy</li>
              <li className="py-2">Terms</li>
            </ul>
          </div>
          */}
        </div>
      </div>
    </>
  );
};

export { Footer };
